// stats counter 
document.addEventListener('DOMContentLoaded', () => {
      const counters = document.querySelectorAll('.number');
      const speed = 200;

      const animateCounters = () => {
          counters.forEach(counter => {
              counter.innerText = '0';
              const target = +counter.getAttribute('data-target');
              const updateCount = () => {
                  const count = +counter.innerText;
                  const increment = target / speed;
                  if (count < target) {
                      counter.innerText = Math.ceil(count + increment);
                      setTimeout(updateCount, 1);
                  } else {
                      counter.innerText = target;
                  }
              };
              updateCount();
          });
      };

      const observerOptions = {
          root: null,
          rootMargin: '0px',
          threshold: 0.1
      };

      const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  animateCounters();
              }
          });
      }, observerOptions);

      const statsSection = document.getElementById('stats');
      if (statsSection) {
      observer.observe(statsSection);
      }
  });